import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography from "@insite/mobius/Typography";
import { generateLinksFrom } from "@tCooneyBrothers/Overrides/Components/PageBreadcrumbs";
import * as React from "react";
import { connect } from "react-redux";

const mapStateToProps = (state: ApplicationState) => {
    return {
        links: state.components.breadcrumbs.links,
        linksState: state.links,
        nodeId: getCurrentPage(state).nodeId,
    };
};

type props = WidgetProps & ReturnType<typeof mapStateToProps>;

const BrandTitle: React.FC<props> = props => {
    const links = props.links || generateLinksFrom(props.linksState, props.nodeId);

    return (
        <Typography variant="h1" size="32px">
            {links[1]?.children === "brands" && links[3]?.children === "Shop All Products" ? (
                <>{links[2]?.children}</>
            ) : null}
        </Typography>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, undefined)(BrandTitle),
    definition: {
        displayName: "Brand Title",
        group: "Catalog",
    },
};

export default widgetModule;
